/*
作者：刘清政（llnb）
时间：2021/5/5
作用：
*/
import Vue from "vue"
import cookies from "vue-cookies";

Vue.mixin({
    methods: {
        hasPermission() {
            let userinfo = cookies.get('userinfo')
            if (userinfo.role === 2) {
                return true
            } else {
                return false
            }
        }
    }
})
